import {
  setPageMeta,
  setPagePosition as setPagePositionAction,
  setSessionToken as setSessionTokenAction,
} from 'actions/tracking.actions';
import { useSelector, useDispatch } from 'react-redux';

function useTrackingMetadata() {
  //grab trk info from local storage that's been passed from csweb
  const dispatch = useDispatch();
  const tracking = useSelector(state => state.tracking);
  const {
    pageNameMeta,
    pageName,
    oldPageNameMeta,
    oldPageName,
    creditProfileMeta,
    userMeta,
    pagePosition,
  } = tracking;

  const setPagePosition = newPagePosition => {
    dispatch(setPagePositionAction(newPagePosition));
  };

  const setSessionToken = newSessionToken => {
    dispatch(setSessionTokenAction(newSessionToken));
  };

  function buildPageMeta(newPageName) {
    dispatch(setPageMeta(newPageName, pageName));
  }

  return {
    userMeta,
    creditProfileMeta,
    pageNameMeta,
    pageName,
    buildPageMeta,
    oldPageNameMeta,
    oldPageName,
    pagePosition,
    setPagePosition,
    setSessionToken,
  };
}

export default useTrackingMetadata;
